module.exports = __webpack_public_path__ + "static/media/disclosure.71e9c72e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/dropdown/disclosure.svg
// module id = 196
// module chunks = 0